import React, { useEffect } from "react";
import "../../src/policy.css";
import { Link, useNavigate } from "react-router-dom"; // Assuming you're using React Router
import AOS from 'aos';
import 'aos/dist/aos.css';
const PrivacyPolicy = () => {
  document.title = "Privacy Policy";
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
        duration: 1000,     
        mirror: true, 
    });
}, []);

  return (
    <>
      <section className="breadcrumb-area pt-10px bg-gray"  data-aos=
            'fade-up'>
              <div className="container">
                <div className="breadcrumb-content d-flex flex-wrap align-items-center justify-content-between pb-10px">
                  <div className="section-heading">
                    <h2 className="fs-24 text-black">Privacy Policy</h2>
                  </div>
                  <ul className="generic-list-item-black generic-list-item-arrow d-flex flex-wrap align-items-center">
                    <li>
                      <Link
                        to="/"
                        onClick={() => (window.location.href = "/")}
                        className="text-black"
                      >
                        Home
                      </Link>
                    </li>
                    <li>Privacy Policy</li>
                  </ul>
                </div>
                {/* end breadcrumb-content */}
              </div>
              {/* end container */}
            </section>
    <div className="policy-page"  data-aos=
            'fade-up'>
      <div className="policy-container">
        <header>
          <h2>Privacy Policy for Lens By HR Fusion</h2>
          <p className="effective-date">
            <strong>Effective Date:</strong> 24th January 2025
          </p>
        </header>

        <section className="section">
          <h3>Introduction</h3>
          <p>
            Aitsil is committed to protecting the privacy of its users. This
            Privacy Policy outlines how we collect and use personal information
            in connection with the Lens By HR Fusion App. By using the App, you
            agree to the terms of this Privacy Policy.
          </p>
        </section>

        <section className="section">
          <h4>1. Information We Collect</h4>
          <div className="sub-section">
            <p>
              <strong>1.1 Photos of Staff:</strong>
            </p>
            <ul>
              <li>
                Photos are collected to enable facial recognition for attendance
                purposes.
              </li>
            </ul>
            <p>
              <strong>1.2 Attendance Logs:</strong>
            </p>
            <ul>
              <li>
                We collect punch-in and punch-out records, including timestamps.
              </li>
            </ul>
            <p>
              <strong>1.3 Admin Login Information:</strong>
            </p>
            <ul>
              <li>
                Admin credentials are collected for authentication and access
                management.
              </li>
            </ul>
          </div>
        </section>

        <section className="section">
          <h4>2. How We Use the Information</h4>
          <div className="sub-section">
            <p>
              <strong>2.1 Attendance Management:</strong>
            </p>
            <ul>
              <li>
                Photos and facial recognition data are used to record attendance
                accurately.
              </li>
            </ul>
            <p>
              <strong>2.2 Log Maintenance:</strong>
            </p>
            <ul>
              <li>
                Attendance logs are maintained for record-keeping and reporting.
              </li>
            </ul>
          </div>
        </section>

        <section className="section">
          <h4>3. Data Security</h4>
          <div className="sub-section">
            <p>
              We implement measures to protect personal information from
              unauthorized access, alteration, or disclosure.
            </p>
          </div>
        </section>

        <section className="section">
          <h4>4. Data Retention</h4>
          <div className="sub-section">
            <p>
              Photos and logs are retained only as long as necessary for
              attendance purposes.
            </p>
          </div>
        </section>

        <section className="contact mb-4">
          <h4>5. Contact Us</h4>
          <div className="sub-section">
            <p>
              If you have any questions or concerns about this Privacy Policy,
              please contact us on{" "}
              <a href="mailto:marketing@aitsil.in" className="text-primary">
                marketing@aitsil.in
              </a>
            </p>
          </div>
        </section>

        <section className="acknowledgment">
          <h3>Acknowledgment</h3>
          <p>
            By using Lens By HR Fusion App, you acknowledge that you have read
            and understood this Privacy Policy.
          </p>
        </section>
      </div>
    </div>
    </>
  );
};

export default PrivacyPolicy;